import React from "react";
import minusIcon from "../Asset/minus.svg";

const MinusIcon = () => {
  return (
    <div className="minus-icon-block m-1">
        {/* <i className="fa fa-edit fa-lg click m-1 px-1" onClick={() => eyeclick(item)} aria-hidden="true" style={{ color: ' #1a3464', fontSize: "1.8rem" }}></i>
        <i class="fa fa-minus" aria-hidden="true"></i> */}
      <img className="minus-icon h-50" src={minusIcon} alt=""/>
    </div>
  );
};
export default MinusIcon;